import { Stack, Typography, Divider } from "@mui/material";
import { TEXT_PRIMARY_DARK, TEXT_SECONDARY } from "@/config/mui/colorPalette";
import { formattedPrice } from "@/utils";
import { MedspaPackage } from "@/views/online-store/onlineStoreView";
import PackageItemsList from "./packageItemsList";

type PackageCardContentProps = {
  packageName: string;
  packagePrice: number;
  packageSavings: number;
  packageItems: MedspaPackage["packageItems"];
  isMobile: boolean;
  maxVisibleItems?: number;
};

const MAX_VISIBLE_ITEMS = 2;

export default function PackageCardContent({
  packageName,
  packagePrice,
  packageSavings,
  packageItems,
  isMobile,
}: PackageCardContentProps) {
  return (
    <Stack sx={{ gap: 1, px: 0.5 }}>
      <Stack p={0.5}>
        <Typography
          variant="subtitleDefault"
          noWrap
          sx={{
            color: TEXT_PRIMARY_DARK,
          }}
        >
          {packageName}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Typography
            variant={isMobile ? "labelDefault" : "labelSmall"}
            sx={{
              color: TEXT_PRIMARY_DARK,
            }}
          >
            {formattedPrice(packagePrice)}
          </Typography>
          {Number(packageSavings) > 0 && (
            <Typography
              variant={isMobile ? "labelDefault" : "labelSmall"}
              sx={{
                textDecoration: "line-through",
                color: TEXT_SECONDARY,
              }}
            >
              {formattedPrice(Number(packagePrice) + Number(packageSavings))}
            </Typography>
          )}
        </Stack>
      </Stack>

      <Divider sx={{ mx: 0.5 }} />

      <Stack sx={{ px: 0.5 }}>
        <PackageItemsList
          packageItems={packageItems}
          maxVisibleItems={MAX_VISIBLE_ITEMS}
        />
      </Stack>
    </Stack>
  );
}
